import { useEffect, useState } from "react";
import { useIdleTimer as useReactIdleTimer } from "react-idle-timer";
import { getPosConfigurations } from "../../../../config/Services";
import { useSnackbar } from "./SnackbarProvider";

const useIdleChecker = () => {
  const [stat, setStat] = useState("Active");
  const [count, setCount] = useState(0);
  const [remaining, setRemaining] = useState(0);
  const [timeoutValue, setTimeoutValue] = useState(18000000);
  const orgId = localStorage.getItem("orgId");
  let throttle = 500;
  const showSnackbar = useSnackbar();

  useEffect(() => {
    // Check localStorage first for orgConfig
    const storedOrgConfig = localStorage.getItem("orgConfig");
    if (storedOrgConfig) {
      try {
        const parsedConfig = JSON.parse(storedOrgConfig);
        const newTimeoutValue = parsedConfig?.idleTimeout;
        if (newTimeoutValue && newTimeoutValue > 0) {
          setTimeoutValue(newTimeoutValue);
          return; // Use cached value, don't call API
        }
      } catch (e) {
        console.log("Error parsing stored orgConfig:", e);
      }
    }

    // Only call API if not in localStorage
    getPosConfigurations(orgId)
      .then((resp) => {
        if (!!resp?.data?.es) {
          return;
        }
        const newTimeoutValue = resp?.data?.configuration?.idleTimeout;
        if (newTimeoutValue && newTimeoutValue > 0) {
          setTimeoutValue(newTimeoutValue);
        } else {
          showSnackbar("Invalid timeout value from configuration", "error");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [orgId]);

  const onIdle = () => {
    setStat("Idle");
  };

  const onActive = () => {
    setStat("Active");
  };

  const onAction = () => {
    setCount(count + 1);
  };

  const { getRemainingTime } = useReactIdleTimer({
    onIdle,
    onActive,
    onAction,
    timeout: timeoutValue,
    throttle,
    promptBeforeIdle: timeoutValue / 2,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime() / 1000));
    }, throttle);

    return () => {
      clearInterval(interval);
    };
  }, [getRemainingTime, throttle]);

  return {
    stat,
    count,
    remaining,
    timeoutValue,
  };
};

export default useIdleChecker;
